module.exports = __webpack_public_path__ + "img/sup_kyc_9.b02023db.jpg";